import {
  Button,
  Col,
  Dropdown,
  Icon,
  Input,
  Menu,
  notification,
  Row,
  Spin,
  Switch,
  Table,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Creators as FinancialPaymentMethodActions } from "../../../../../../store/ducks/financialPaymentMethod";
import ButtonStandard from "../../../../../../components/utils/button";
import MenuIcon from "../../../../../../components/utils/table/icons/menu";
import { Container as MenuContainer } from "../../../../../../components/utils/table/menu/styles";
import TagStatus from "../../../../../../components/utils/tagStatus";
import {
  getParameterItems,
  saveOrUpdateParameter,
} from "../../../../../../services/generalParameterService";
import { CardCustom, TableContainer, Title } from "./styles";
import DrawerFinancialPaymentMethod from "../../../../../../components/drawers/financialPaymentMethod";
import {
  activateFinancialPaymentMethod,
  inactivateFinancialPaymentMethod,
} from "../../../../../../services/financialPaymentMethodService";

// import { Container } from './styles';

const CODES_PARAMETERS = [4004];

function FinancialPaymentMethod() {
  const [isLoading, setIsLoading] = useState(false);
  const [parametersValue, setParametersValue] = useState([]);
  const [parameter4004Value, setParameter4004Value] = useState(null);

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const {
    financialPaymentMethodTableData: dataList,
    loadingFinancialPaymentMethodTableData: isLoadingDataList,
  } = useSelector((state) => state.financialPaymentMethod);

  const dispatch = useDispatch();

  const getParameters = useCallback(async () => {
    setIsLoading(true);
    let dataResult = [];
    try {
      for (var i = 0; i < CODES_PARAMETERS.length; i++) {
        let code = CODES_PARAMETERS[i];
        let {
          data: { results },
        } = await getParameterItems({ groupId, farmId, code });
        results.isDefault = results.farmId == null && results.groupId == null;
        results.updated = false;
        dataResult.push(results);
      }
      setParametersValue(dataResult);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [farmId, groupId]);

  const fetchData = useCallback(() => {
    dispatch(
      FinancialPaymentMethodActions.getFinancialPaymentMethod(groupId, farmId)
    );
  }, [dispatch, farmId, groupId]);

  const handleChangeParameter4004Value = useCallback(
    async (parameter4004Value, checked) => {
      setIsLoading(true);
      try {
        const newParameter4004Value = {
          ...parameter4004Value,
          value: `${checked}`,
          updated: true,
        };
        setParameter4004Value(newParameter4004Value);
        await saveOrUpdateParameter({
          groupId,
          farmId,
          parameterItemId: newParameter4004Value.id,
          parameterId: newParameter4004Value.parameterId,
          edit: !newParameter4004Value.isDefault,
          body: newParameter4004Value,
        });
        notification.success({
          message: translation.generalParameters.successParameterUpdated,
        });
        getParameters();
      } catch (error) {
        notification.error({
          message: translation.generalParameters.errorParameterUpdated,
        });
      } finally {
        setIsLoading(false);
      }
    },
    [
      farmId,
      getParameters,
      groupId,
      translation.generalParameters.errorParameterUpdated,
      translation.generalParameters.successParameterUpdated,
    ]
  );

  const handleEdit = useCallback(
    (record) => {
      dispatch(
        FinancialPaymentMethodActions.switchDrawerFinancialPaymentMethodVisibility(
          record
        )
      );
    },
    [dispatch]
  );

  const handleDelete = useCallback(async (id) => {
    try {
      // await destroy({ groupId, farmId, id });
      notification.success({
        message: translation.financialPaymentMethod.messages.deleteSuccess,
      });
      // fetchData();
    } catch (error) {
      if (Object.keys(error).includes("response")) {
        const { response } = error;
        if (Object.keys(response).includes("data")) {
          const {
            data: { code: errorCode },
          } = response;
          if (errorCode === 5005) {
            notification.error({
              message: translation.financialPaymentMethod.messages.errorTitle,
              description: translation.financialPaymentMethod.messages.linkedError,
            });
          } else {
            notification.error({
              message: translation.financialPaymentMethod.messages.errorTitle,
              description: translation.financialPaymentMethod.messages.deleteError,
            });
          }
        }
      } else {
        notification.error({
          message: translation.financialPaymentMethod.messages.errorTitle,
          description: translation.financialPaymentMethod.messages.deleteError,
        });
      }
    } finally {
    }
  }, []);

  const handleActivate = useCallback(
    async (id) => {
      try {
        await activateFinancialPaymentMethod({ groupId, farmId, id });
        notification.success({
          message: translation.financialPaymentMethod.messages.activateMessage,
        });
        fetchData();
      } catch (error) {
        notification.error({
          message: translation.financialPaymentMethod.messages.errorMessage,
        });
      }
    },
    [
      groupId,
      farmId,
      translation.financialPaymentMethod.messages.activateMessage,
      translation.financialPaymentMethod.messages.errorMessage,
      fetchData,
    ]
  );

  const handleInactivate = useCallback(
    async (id) => {
      try {
        await inactivateFinancialPaymentMethod({ groupId, farmId, id });
        notification.success({
          message:
            translation.financialPaymentMethod.messages.inactivateMessage,
        });
        fetchData();
      } catch (error) {
        notification.error({
          message: translation.financialPaymentMethod.messages.errorMessage,
        });
      }
    },
    [
      groupId,
      farmId,
      translation.financialPaymentMethod.messages.inactivateMessage,
      translation.financialPaymentMethod.messages.errorMessage,
      fetchData,
    ]
  );

  const handleSearch = useCallback((selectedKeys, confirm, dataIndex) => {
    confirm();
  }, []);

  const handleReset = useCallback((clearFilters) => {
    clearFilters();
  }, []);

  const handleGetColumnSearchProps = useCallback(
    (dataIndex) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon="search"
            size="small"
            style={{
              width: 90,
              marginRight: 8,
              background: "#684e94",
              borderColor: "none",
              border: "none",
            }}
          />
          <Button
            onClick={() => handleReset(clearFilters)}
            icon="delete"
            size="small"
            style={{ width: 90 }}
          />
        </div>
      ),
      filterIcon: (filtered) => (
        <Icon
          type="search"
          style={{ color: filtered ? "#684e94" : undefined }}
        />
      ),
      onFilter: (value, record) => {
        if (dataIndex === "males") {
          return record[dataIndex]
            ?.map((m) => m.animalHandlingNumber.toLowerCase())
            .join(" ")
            .includes(value.toString().toLowerCase());
        } else {
          return record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value.toString().toLowerCase());
        }
      },
    }),
    [handleReset, handleSearch]
  );

  const handleOpenDrawer = () => {
    dispatch(
      FinancialPaymentMethodActions.switchDrawerFinancialPaymentMethodVisibility()
    );
  };

  const menu = (id, record) => {
    return (
      <Menu>
        {record.status === "Active" && (
          <Menu.Item onClick={() => handleEdit(record)}>
            {translation.table.menu.edit}
          </Menu.Item>
        )}
        {record.status === "Active" && (
          <Menu.Item onClick={() => handleInactivate(id)}>
            {translation.table.menu.inactivate}
          </Menu.Item>
        )}
        {record.status === "Inactive" && (
          <Menu.Item onClick={() => handleActivate(id)}>
            {translation.table.menu.activate}
          </Menu.Item>
        )}
      </Menu>
    );
  };

  useEffect(() => {
    let doFetch = true;
    if (doFetch) {
      getParameters();
      doFetch = false;
    }
    return () => {
      doFetch = true;
    };
  }, [groupId, farmId, getParameters]);

  useEffect(() => {
    if (parametersValue.length > 0) {
      setParameter4004Value(
        parametersValue.find((parameter) => parameter.code === 4004)
      );
    }
  }, [parametersValue]);

  useEffect(() => {
    let doFetch = true;
    if (doFetch) {
      fetchData();
      doFetch = false;
    }

    return () => {
      doFetch = true;
    };
  }, [fetchData]);

  return (
    <CardCustom>
      <Spin spinning={isLoading}>
        <Row type="flex" align="middle" gutter={16}>
          {/* Parameter 4004 */}
          <Col>
            <Row type="flex" justify="center" align="middle" gutter={16}>
              <Col>
                <label htmlFor="parameter4004Value">
                  {translation.financialPaymentMethod.parameter4004}
                </label>
              </Col>
              <Col>
                <Switch
                  id="parameter4004Value"
                  checked={
                    parameter4004Value && parameter4004Value?.value === "true"
                      ? true
                      : false
                  }
                  onChange={(checked) =>
                    handleChangeParameter4004Value(parameter4004Value, checked)
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <TableContainer
          isActive={parameter4004Value?.value === "true" ? true : false}
        >
          <Row className="rowHeader" justify="space-between">
            <Col span={8}>
              <Title>{translation.financialPaymentMethod.title}</Title>
            </Col>
            <Col span={16}>
              <Row type="flex" justify="end" gutter={8}>
                <Col>
                  <ButtonStandard
                    buttonType="typeWithoutBackground"
                    onClick={fetchData}
                  >
                    <Icon type="reload" />
                  </ButtonStandard>
                </Col>
                <Col>
                  <ButtonStandard buttonType="addNew" onClick={handleOpenDrawer}>
                    {translation.financialPaymentMethod.buttonNew}
                  </ButtonStandard>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={24}>
              <Table
                loading={isLoadingDataList}
                rowKey="id"
                size="small"
                dataSource={dataList}
                pagination={{
                  hideOnSinglePage:
                    dataList !== null && dataList.length > 10 ? false : true,
                  showSizeChanger: true,
                  pageSizeOptions: [
                    "10",
                    "20",
                    "30",
                    "100",
                    "500",
                    "1000",
                    "2000",
                  ],
                }}
              >
                <Table.Column
                  title={
                    translation.financialPaymentMethod.table.columns.status
                  }
                  dataIndex="status"
                  key="status"
                  align="left"
                  sorter={(first, second) => {
                    return first.status.localeCompare(second.status, "pt-BR", {
                      numeric: false,
                      ignorePunctuation: true,
                    });
                  }}
                  defaultFilteredValue={["Active"]}
                  filtered
                  filters={[
                    {
                      text: translation.status.active,
                      value: "Active",
                    },
                    {
                      text: translation.status.inactive,
                      value: "Inactive",
                    },
                  ]}
                  filterMultiple
                  onFilter={(value, record) => record.status.includes(value)}
                  render={(status) =>
                    status === "Active" ? (
                      <TagStatus
                        background="#C5F1CA"
                        borderColor="#106518"
                        color="#106518"
                      >
                        {translation.status.active}
                      </TagStatus>
                    ) : (
                      <TagStatus
                        background="#FBC7C7"
                        borderColor="#D44C4C"
                        color="#D44C4C"
                      >
                        {translation.status.inactive}
                      </TagStatus>
                    )
                  }
                />
                <Table.Column
                  title={translation.financialPaymentMethod.table.columns.name}
                  dataIndex="name"
                  sorter={(first, second) => {
                    if (!first.name) {
                      first.name = "";
                    }
                    return first.name.localeCompare(second.name, "pt-BR", {
                      numeric: false,
                      ignorePunctuation: true,
                    });
                  }}
                  key="name"
                  {...handleGetColumnSearchProps("name")}
                />
                <Table.Column
                  title={translation.financialPaymentMethod.table.columns.code}
                  dataIndex="code"
                  sorter={(first, second) => {
                    if (!first.code) {
                      first.code = "";
                    }
                    return first.code.localeCompare(second.code, "pt-BR", {
                      numeric: false,
                      ignorePunctuation: true,
                    });
                  }}
                  key="code"
                  {...handleGetColumnSearchProps("code")}
                />
                <Table.Column
                  title=""
                  align="left"
                  render={(text, record) => (
                    <Dropdown
                      overlay={menu(record.id, record)}
                      trigger={["click"]}
                      key={record.id}
                    >
                      <MenuContainer>
                        <MenuIcon />
                      </MenuContainer>
                    </Dropdown>
                  )}
                />
              </Table>
            </Col>
          </Row>
        </TableContainer>
      </Spin>
      <DrawerFinancialPaymentMethod />
    </CardCustom>
  );
}

export default FinancialPaymentMethod;
